import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { CommonService } from '../../../../services/common/common.service';
import {  VideosDataService,  VideosColumnsService, CategoriesDataService } from '../../../services';
import {  Video,  VideosResult, CategoriesResult } from '../../../interfaces';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';

@Component({
  selector: 'app-post-form',
  templateUrl: './video-form.component.html',
  styleUrls: ['./video-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class  VideoFormComponent implements OnInit {

  public video:  Video = {};
  public videoForm: FormGroup = new FormGroup({});
  public videos:  Video[] = [];
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'fr';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;
  public categories:any;
  selectedFile: File | null;

  public Editor = ClassicEditor;
  categoryValue: any;
  formData = new FormData();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private messageService: MessageService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private videosDataService:  VideosDataService,
    public videosColumnsService:  VideosColumnsService,
    public editorService: EditorService,
    public categoriesDataService: CategoriesDataService
  ) {
    this.selectedFile = null; // Initialize it to a default value, such as null
  }

  ngOnInit(): void {
    this.getCategories();
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.post !== 'undefined') {
      this.video = this.dynamicDialogConfig.data.post;
    }
  if (typeof this.video.id === 'undefined' || this.video.id === null) {
      this.video.id = null;
      this.video.active = false;
  }
    
    this.getVideos();
    this.prepareFrom();
  }


  getCategories(){
    this.categoriesDataService.getCategories().subscribe((response: CategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.categories = response.success.data;
      }
    }, (error: any) => {;
     
    });
  }

  getVideos(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.posts !== 'undefined' && this.dynamicDialogConfig.data.posts.length > 0) {
      this.videos = this.dynamicDialogConfig.data.posts;
      return;
    }
    this.videosDataService.getVideos().subscribe((response: VideosResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.videos = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.videoForm = new FormGroup({
      id: new FormControl(this.video.id, []),
      category: new FormControl(this.categoryValue, [Validators.required, ]),
      title: new FormControl(this.video.title, []),
      TitleEn: new FormControl(this.video.TitleEn, []),
      titleFr: new FormControl(this.video.titleFr, []),
      imagePath: new FormControl(this.video.imagePath, []),
      description: new FormControl(this.video.description, []),
      DescriptionEn: new FormControl(this.video.DescriptionEn, []),
      descriptionFr: new FormControl(this.video.descriptionFr, []),
     
    });
  }

  onChange(e:any) {
    this.categoryValue = e.value;
  }

  list() {
    this.router.navigate(['/posts']);
  }

  showErrors() {
      const invalidFields: string[] = [];
      Object.keys(this.videoForm.controls).forEach((field: any) => {
        const control = this.videoForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.videoForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.video = this.videoForm.value;
    this.disableSubmit = true;
    this.formData.append('title', this.videoForm ? this.videoForm.value.titleFr : null);
    this.formData.append('titleFr', this.videoForm ? this.videoForm.value.titleFr : null);
    this.formData.append('TitleEn', this.videoForm ? this.videoForm.value.TitleEn : null);
    this.formData.append('description', this.videoForm ? this.videoForm.value.descriptionFr : null);
    this.formData.append('descriptionFr', this.videoForm ? this.videoForm.value.descriptionFr : null);
    this.formData.append('DescriptionEn', this.videoForm ? this.videoForm.value.DescriptionEn : null);
    this.formData.append('category', this.categoryValue.id);
    if (this.video.id === null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  update(redirect: boolean) {
    this.videosDataService.updateVideo(this.formData, this.videoForm.value.id).subscribe((data: any) => {
      this.disableSubmit = false;
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      console.warn(error);
    });
  }

  add(redirect: boolean) {
    this.videosDataService.addVideo(this.formData).subscribe((data: any) => {
        this.disableSubmit = false;
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        console.warn(error);
    });
  }

  uploadPhoto(event: any): void {
    this.selectedFile = event.target.files[0] as File;
    if (this.selectedFile) {
      this.formData.append('picture', this.selectedFile);
    }
  }

}

@Component({
  selector: 'app-post-form',
  templateUrl: './video-form.component.html',
  styleUrls: ['./video-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVideoFormComponent extends VideoFormComponent {
}

